"use client"

import { Ruler } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RulerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RulerIcon = component(Icon)({ as: Ruler })
